<script>
import { mapActions, mapState } from 'vuex';
import DateFilters from '../../components/payments/PaymentsDateFilters';
import MainFilters from '../../components/payments/client-payments/ClientPaymentsMainFilters';
import ClientPaymentsTable from '../../components/payments/client-payments/ClientPaymentsTable';

export default {
  name: 'ClientPayments',
  components: {
    DateFilters,
    MainFilters,
    ClientPaymentsTable,
  },
  computed: {
    ...mapState({
      arrivalFromDate: state => state.clientPayments.filter.date.arrivalFromDate,
      arrivalToDate: state => state.clientPayments.filter.date.arrivalToDate,
      paidDateFromDate: state => state.clientPayments.filter.date.paidDateFromDate,
      paidDateToDate: state => state.clientPayments.filter.date.paidDateToDate,
      filterLoading: state => state.clientPayments.filter.data.loading,
      filterError: state => state.clientPayments.filter.data.error,
      loading: state => state.clientPayments.tableData.loading,
      error: state => state.clientPayments.tableData.error,
    }),
    disabled() {
      return this.filterLoading || this.filterError || this.loading;
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      clearState: 'clientPayments/clearState',
      loadFilters: 'clientPayments/getFilterData',
      loadTableData: 'clientPayments/loadTableData',
      updateFilterArrivalFromDate: 'clientPayments/updateFilterArrivalFromDate',
      updateFilterArrivalToDate: 'clientPayments/updateFilterArrivalToDate',
      updateFilterPaidDateFromDate: 'clientPayments/updateFilterPaidDateFromDate',
      updateFilterPaidDateToDate: 'clientPayments/updateFilterPaidDateToDate',
    }),
  },
  created() {
    this.loadFilters();
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('pages.payments'), to: '', disabled: true },
        { text: this.$t('pages.clientPayments'), to: this.$route.path },
      ],
      title: this.$t('pages.clientPayments'),
    });
  },
  beforeRouteLeave(to, from, next) {
    this.clearState();
    next();
  },
};
</script>

<template>
  <v-flex>
    <v-flex v-if="filterLoading || filterError">
      <v-progress-linear v-if="filterLoading" class="ma-0 pa-0" indeterminate/>
      <v-alert :value="filterError" type="error">
        {{ $t('payments.filters.error') }}
      </v-alert>
    </v-flex>
    <v-container fluid>
      <v-layout row>
        <v-flex xs6>
          <main-filters/>
        </v-flex>
        <v-flex xs6>
          <date-filters
            @updateFilterArrivalFromDate="updateFilterArrivalFromDate"
            @updateFilterArrivalToDate="updateFilterArrivalToDate"
            @updateFilterPaidDateFromDate="updateFilterPaidDateFromDate"
            @updateFilterPaidDateToDate="updateFilterPaidDateToDate"
            :arrival-from-date="arrivalFromDate"
            :arrival-to-date="arrivalToDate"
            :paid-date-from-date="paidDateFromDate"
            :paid-date-to-date="paidDateToDate"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
      <v-layout row mt-3>
        <v-btn
          @click="loadTableData"
          :disabled="disabled"
          color="primary darken-1"
          block
        >
          {{ $t('inputs.search') }}
        </v-btn>
      </v-layout>
      <v-layout row v-if="!filterLoading && !filterError">
        <client-payments-table @refresh="loadTableData"/>
      </v-layout>
    </v-container>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/Payments/ClientPayments.vue